import {ActionType} from "../model";


export const getAdminActionItem = (payload:any = {}) => async (dispatch: Function, getState: Function, api: any)  => {
    try {
        return await api.post(`admin-actions/get`, {...payload}, {});
    } catch(err) {
        dispatch({
            type: ActionType.ALERT,
            payload: err
        });
        return false;
    }
};